<template>
    <div class="container-fluid bg-light h-100-vh">
        <!-- end page title -->
        <div class="row">
            <div class="col-md-7 col-12">
                <div class="container pt-3">
                    <div class="row py-3">
                        <div class="col-md-6 col-sm-12">
                            <form @submit="submitSearchItem" class="form-inline">
                                <div class="input-group w-100 my-1">
                                    <input type="text" ref="search_item_focus" class="form-control" v-model="searchItemTerm" placeholder="Search Items">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary" type="submit">
                                                            <i class="fa fa-search"></i>
                                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <b-form-select v-model="selectedCategory" :options="prodCategoryOptions" class="my-1">
                                <!-- This slot appears above the options from 'options' prop -->
                                <template #first>
                                                        <b-form-select-option :value="''" >-- All Categories --</b-form-select-option>
</template>


                            </b-form-select>

                        </div>

                    </div>



                </div>

                    <div class="container">
                        <div class="row">
                            <div class="col-md-4 col-sm-12">
                                <h5 class="py-3"> {{s_productcategory}} - ({{ products.length  }})</h5>
                                <!-- <h5 class="py-3" v-else > {{s_productcategory}}</h5> -->
                            </div>
                            <div class="col-md-4 col-sm-6">


                                <div class="py-3" v-if="companySettings.has_wholesale === 1 ">
                                    <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="is_Retail" checked>
                                    <label v-if="is_Retail === true" class="custom-control-label" for="customSwitch1">Retails Prices Set</label>
                                    <label v-if="is_Retail === false" class="custom-control-label text-danger" for="customSwitch1">Wholesale Prices Set</label>
                                    </div>
                                </div>

                            </div>
                            <div class="col-md-3 col-sm-5">
                                <select v-model="sortProducts" class="form-control">
                                    <option value="null">Sort</option>
                                    <option value="name-desc">Name Desc</option>
                                    <option value="name-asc">Name Asc</option>
                                    <option value="price-asc">Price Asc</option>
                                    <option value="price-desc">Price Desc</option>

                                </select>



                                </div>
                                <div class="col-md-1 col-sm-1 text-center">

                                    <a href="#" class="text-dark" @click="hotReload"><span class="align-middle"><i class="fa fa-refresh"></i></span></a>
                                     <p><small>Reload</small></p>

                                </div>

                        </div>

                    </div>

<template>
    <div v-if="products.length > 0" style="margin-bottom: 5em;">
        <!-- Toggle Button -->
        <div class="d-flex justify-content-end mb-3 pt-1">
            <label class="switch">
                        <input type="checkbox" v-model="isListView">
                        <span class="slider round"></span>
                      </label>
            <span class="ml-2">{{ isListView ? 'List View' : 'Grid View' }}</span>
        </div>
        <!-- List View -->
        <div v-if="isListView">
            <div v-if="companySettings.has_stock_buffer === 0">
                <div class="list-group">
                    <div v-for="product in products" :key="product.id" class="list-group-item d-flex align-items-center p-3 shadow-sm" v-if="((product.remaining_units > 0 && !product.is_service) || product.is_service) && product.can_be_sold " @click="addToCart(product)">
                        <!-- Product Image -->
                        <img v-if="product.img !== ''" :src="product.img" class="rounded mr-3" style="width: 60px; height: 60px; object-fit: cover;" />
                        <div v-else class="rounded mr-3 d-flex align-items-center justify-content-center" :style="{ width: '60px', height: '60px', background: product.bg_color }">
                            <span class="text-light">{{ product.product.charAt(0) }}</span>
                        </div>
                        <!-- Product Details -->
                        <div class="flex-grow-1">
                            <h6 class="mb-0">{{ product.product }}</h6>
                            <small v-if="userDetails.roles[0].name === 'Admin' || companySettings.allow_employees_see_stock_count === 1" class="badge badge-secondary">
                                {{ product.remaining_units }} in stock
                                </small>
                        </div>
                        <!-- Add to Cart -->
                        <button class="btn btn-primary btn-sm" @click="addToCart(product)">
                                Add to Cart
                            </button>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="list-group">
                    <div v-for="product in products" :key="product.id" class="list-group-item d-flex align-items-center p-3 shadow-sm" v-if="product.can_be_sold">
                        <!-- Product Image -->
                        <img v-if="product.img !== ''" :src="product.img" class="rounded mr-3" style="width: 60px; height: 60px; object-fit: cover;" />
                        <div v-else class="rounded mr-3 d-flex align-items-center justify-content-center" :style="{ width: '60px', height: '60px', background: product.bg_color }">
                            <span class="text-light">{{ product.product.charAt(0) }}</span>
                        </div>
                        <!-- Product Details -->
                        <div class="flex-grow-1">
                            <h6 class="mb-0">{{ product.product }}</h6>
                            <small v-if="userDetails.roles[0].name === 'Admin' || companySettings.allow_employees_see_stock_count === 1" class="badge badge-secondary">
                                {{ product.remaining_units }} in stock
                                </small>
                        </div>
                        <!-- Add to Cart -->
                        <button class="btn btn-primary btn-sm" @click="addToCart(product)">
                                Add to Cart
                            </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Grid View -->
        <div v-else>
            <div class="row no-gutters" v-if="companySettings.has_stock_buffer === 0">
                <div class="col-md-3 col-6 py-1 px-lg-1" v-for="product in products" :key="product.id" v-if="((product.remaining_units > 0 && !product.is_service) || product.is_service) && product.can_be_sold" @click="addToCart(product)">
                    <div v-if="product.img !== ''" class="card h-100 rounded shadow-sm">
                        <div class="card-body">
                            <img :src="product.img" alt="" class="img-fluid rounded card-img-top shadow-sm">
                            <div class="text-center">
                                <h6 class="text-center">{{ product.product }}</h6>
                            </div>
                        </div>
                    </div>
                    <div v-else class="card h-100 rounded shadow-sm">
                        <div class="card-body rounded" :style="{ background: product.bg_color }">
                            <div class="square-item-bg">
                                <div class="text-center py-5">
                                    <h6 class="text-center text-light">{{ product.product }}</h6>
                                    <small v-if="userDetails.roles[0].name === 'Admin'" class="badge badge-light rounded px-1 py-1 mt-2">
                                    {{ product.remaining_units }}

                                  </small>
                                    <small v-else-if="companySettings.allow_employees_see_stock_count === 1" class="badge badge-light rounded px-1 py-1 mt-2">
                                    {{ product.remaining_units }}
                                  </small>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row no-gutters" v-else>
                <div class="col-md-3 col-6 py-1 px-lg-1" v-if="product.can_be_sold" v-for="product in products" :key="product.id" @click="addToCart(product)">
                    <div v-if="product.img !== '' && companySettings.items_have_images" class="card h-100 rounded shadow-sm">
                        <div class="card-body d-flex justify-content-center align-items-center">
                            <img :src="product.img" alt="" class="img-fluid card-img-top">
                        </div>
                        <div class="text-center">
                            <h6>{{ product.product }}</h6>
                        </div>
                    </div>
                    <div v-else class="card h-100 rounded shadow-sm">
                        <div class="card-body rounded" :style="{ background: product.bg_color }">
                            <div class="square-item-bg">
                                <div class="text-center py-5">
                                    <h6 class="text-center text-light">{{ product.product }}</h6>
                                    <small v-if="userDetails.roles[0].name === 'Admin'" class="badge badge-light rounded px-1 py-1 mt-2">
                                    {{ product.remaining_units }}
                                  </small>
                                    <small v-else-if="companySettings.allow_employees_see_stock_count === 1" class="badge badge-light rounded px-1 py-1 mt-2">
                                    {{ product.remaining_units }}
                                  </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>







            </div>


            <div class="col-md-5 d-none d-sm-block col-12 ">
                    <div class="card h-100 d-none d-sm-block">
                        <div class="card-body">
                            <div class="text-dark text-center">
                                Cart ({{ $store.state.cartCount }})
                            </div>
                            <hr/>
                            <div class="text-center" v-if="message_feedback">
                                <h6 class="text-danger">{{message_feedback}}</h6>
                            </div>
                            <button class="btn btn-block btn-outline-dark" @click="showCustomersModal">
                                <span class="h5">
                                    <i class="bi bi-person-circle"></i>
                                </span>
                                <span v-if="$store.state.customerdata !=='Select Customer'">
                                    {{$store.state.customerdata.full_name}}
                                </span>
                                <span v-else class="text-danger">
                                    Add Customer Details
                                </span>
                                </button>
                            <div v-if="$store.state.cart.length > 0" class="navbar-dropdown is-boxed is-right">
                            <div class="table-responsive">
                                <table class="table">

                                    <tbody>

                                    <tr v-for="cart in $store.state.cart" v-bind:key='cart.id'>

                                        <td><span class="h6">{{cart.product}}</span></td>
                                        <td><span class="badge badge-secondary" @click="changeQuantity(cart)">{{cart.quantity}}</span></td>
                                        <td v-if="cart.is_service || companySettings.allows_price_change_on_the_go" @click="changePricingOnTheGo(cart)" class="border-0"><span class="h6">{{convertCurrencyToLocal(cart.totalPrice)}}</span></td>
                                        <td v-else class="border-0"><span class="h6">{{convertCurrencyToLocal(cart.totalPrice)}}</span></td>



                                        <td class="border-0 align-middle">
                                            <span class="removeBtn"
                                                  title="Remove from cart"
                                                  @click.prevent="removeFromCart(cart)"><i class="fa fa-trash"></i></span>
                                            </td>
                                    </tr>

                                    </tbody>
                                </table>
                            </div>
                            </div>
                            <hr/>
                            <div class="row">
                                <div class="float-left col-6"><h6 class="text-left">Sub Total </h6></div>
                                <div class="float-right col-6"><h6 class="text-right">{{ convertCurrencyToLocal(totalPrice) }}</h6></div>
                            </div>
                            <hr />
                            <div class="row">
                                    <div class="col-6"><h6 class="text-left">Order discount </h6>

                                    </div>
                                    <div class="col-6">

                                        <div class="input-group mb-2">
                                            <div class="input-group-prepend">
                                            <div class="input-group-text">{{ userDetails.company.companysettings.currency }}</div>
                                            </div>
                                            <input type="number" v-model=totalDiscountApplied class="form-control" id="inlineFormInputGroup">

                                        </div>
                                        <div v-if="discountError">
                                            <small class="text-danger">{{ discountError }}</small>
                                        </div>
                                        </div>



                            </div>

                            <hr />
                            <div class="row">
                                <div class="float-left col-6"><h6 class="text-left">Grand Total </h6></div>
                                <div class="float-right col-6"><h6 class="text-right"> {{ convertCurrencyToLocal(grandTotalAmount) }}</h6></div>
                            </div>
                            <hr />

                            <div class="pt-4">
                               <button v-if="!companySettings.skip_checkout_done" ref="submitButton" @click="Submit" :class="['btn', 'btn-primary', 'btn-block', { 'disabled': isSubmitting }]"
                                :disabled="isSubmitting">Complete -  {{convertCurrencyToLocal( grandTotalAmount )}}</button>
                                <div v-else>
                                    <MiniCheckout />
                                </div>
                            </div>

                        </div>

                    </div>

            </div>

            </div>
            <a href="#" @click="showCartModal" class="float d-sm-block d-xs-block d-md-none text-light">
               <i class="fa fa-shopping-bag my-float"></i>  <span class="text-light">{{ $store.state.cartCount }}</span>
            </a>
        <b-modal ref="cart-modal" hide-footer>
            <div class="card h-100">
                        <div class="card-body">
                            <div class="text-dark text-center">
                                Cart ({{ $store.state.cartCount }})
                            </div>
                            <hr/>
                            <div class="text-center" v-if="message_feedback">
                                <h6 class="text-danger">{{message_feedback}}</h6>
                            </div>
                            <button class="btn btn-block btn-outline-dark" @click="showCustomersModal">
                                <span class="h5">
                                    <i class="bi bi-person-circle"></i>
                                </span>
                                <span v-if="$store.state.customerdata !=='Select Customer'">
                                    {{$store.state.customerdata.full_name}}
                                </span>
                                <span v-else class="text-danger">
                                    Add Customer Details
                                </span>
                                </button>
                            <div v-if="$store.state.cart.length > 0" class="navbar-dropdown is-boxed is-right">
                            <div class="table-responsive">
                                <table class="table">

                                    <tbody>

                                    <tr v-for="cart in $store.state.cart" v-bind:key='cart.id'>

                                        <td><small>{{cart.product}}</small></td>
                                        <td><small class="badge badge-secondary" @click="changeQuantity(cart)">{{cart.quantity}}</small></td>
                                        <td v-if="cart.is_service || companySettings.allows_price_change_on_the_go" @click="changePricingOnTheGo(cart)" class="border-0"><small> {{convertCurrencyToLocal(cart.totalPrice)}}</small></td>
                                        <td v-else class="border-0"><small> {{convertCurrencyToLocal(cart.totalPrice)}}</small></td>

                                        <td class="border-0 align-middle">
                                            <span class="removeBtn"
                                                  title="Remove from cart"
                                                  @click.prevent="removeFromCart(cart)"><i class="fa fa-trash"></i></span>
                                            </td>
                                    </tr>

                                    </tbody>
                                </table>
                            </div>
                            </div>
                            <hr/>
                            <div class="row">
                                <div class="float-left col-6"><h6 class="text-left">Sub Total </h6></div>
                                <div class="float-right col-6"><h6 class="text-right">{{ convertCurrencyToLocal(totalPrice) }}</h6></div>
                            </div>
                            <hr />
                            <div class="row">
                                    <div class="col-6"><h6 class="text-left">Order discount </h6>

                                    </div>
                                    <div class="col-6">

                                        <div class="input-group mb-2">
                                            <div class="input-group-prepend">
                                            <div class="input-group-text">{{ userDetails.company.companysettings.currency }}</div>
                                            </div>
                                            <input type="number" v-model=totalDiscountApplied class="form-control" id="inlineFormInputGroup">
                                        </div>
                                        <div v-if="discountError">
                                            <small class="text-danger">{{ discountError }}</small>
                                        </div>
                                        </div>



                            </div>

                            <hr />
                            <div class="row">
                                <div class="float-left col-6"><h6 class="text-left">Grand Total </h6></div>
                                <div class="float-right col-6"><h6 class="text-right"> {{ convertCurrencyToLocal(grandTotalAmount) }}</h6></div>
                            </div>
                            <hr />



                             <div class="pt-4">
                               <button v-if="!companySettings.skip_checkout_done" ref="submitButton" @click="Submit" :class="['btn', 'btn-primary', 'btn-block', { 'disabled': isSubmitting }]"
                                :disabled="isSubmitting">Complete -  {{convertCurrencyToLocal( grandTotalAmount )}}</button>
                                <div v-else>
                                    <MiniCheckout />
                                </div>
                            </div>




                        </div>

                    </div>
        </b-modal>

        <b-modal ref="changePriceModal" hide-footer static>
            <div class="d-block text-center">
                <h2 class="font-weight-bold ">Price</h2>
                <form @submit.prevent="processNewPricesOnTheGo">
                    <input class="form-control border border-dark my-3"  v-model="newServicePricing" type="text" />
                    <small class="text-danger">Note this is the selling price per item/service. Current - {{ selecteCartDetails.ppu }} </small>
                    <input class="form-control border border-dark my-3" v-bind:value=selecteCartDetails.id type="hidden" />
                    <button type="submit" class="btn btn-block btn-primary">Update Amount</button>
                </form>
                <!--<i @click="qtyDecrease()" class="bi bi-dash-square-fill"></i>  <i @click="qtyIncrease()"class="bi bi-file-plus-fill"></i>-->
            </div>

        </b-modal>
        <b-modal ref="orderqty-modal" hide-footer static>
            <div class="d-block text-center">
                <h2 class="font-weight-bold ">Quantity</h2>
                <form @submit.prevent="processNewQty">
                    <input class="form-control border border-dark my-3"  v-model="newQty" type="text" />
                    <input class="form-control border border-dark my-3" v-bind:value=selecteCartDetails.id type="hidden" />
                    <button type="submit" class="btn btn-block btn-primary">Update Quantity</button>
                </form>
                <!--<i @click="qtyDecrease()" class="bi bi-dash-square-fill"></i>  <i @click="qtyIncrease()"class="bi bi-file-plus-fill"></i>-->
            </div>

        </b-modal>
        <b-modal id="customer-modal-sales" ref="customers-modal" hide-footer static>
            <div class="row">

                <div class="col"><h2 class="font-weight-bold ">{{selectedCustomer}}</h2></div>
                <div class="col d-flex justify-content-end">

                    <a class="btn btn-primary btn-sm " @click="AddnewcustomerModal">New Customer <i class="bi bi-plus-square-fill "></i></a>
                </div>

                <div class="container py-3">

                  <!-- Actual search box -->
                  <div class="form-group has-search">
                      <span class="fa fa-search form-control-feedback"></span>
                      <input type="text" v-model="searchCustomer" class="form-control border" placeholder="Search">
                  </div>
                  <ul>
                      <li class="border-bottom" v-if="customer" v-for="customer in allCustomersFiltered" v-bind:key='customer.id' @click="SelectCustomer(customer)">
                          <div class="row">
                              <div class="col-6">  <h6 v-if="customer.full_name" class="text-left">{{customer.full_name}}</h6>
                                  <p class="text-gray d-inline">{{customer.address_address}}</p></div>
                              <div class="col-6">
                                  <p class="text-gray text-right">{{customer.phone}}</p>
                              </div>


                          </div>


                      </li>

                  </ul>
              </div>

            </div>

        </b-modal>
        <b-modal ref="customers-modal-final" scrollable hide-footer static>
            <div class="container  d-flex justify-content-end">

                <a class="btn btn-primary btn-sm" @click="AddnewcustomerModal">Add New Customer <i class="bi bi-plus-square-fill "></i></a>
            </div>
                <div class="container py-3">
                    <!-- Actual search box -->
                    <div class="form-group has-search">
                        <span class="fa fa-search form-control-feedback"></span>
                        <input type="text" v-model="searchCustomer" class="form-control border" placeholder="Search">
                    </div>
                    <ul class="overflow-auto">
                        <li v-if="customer" class="border-bottom underline-primary"  v-for="customer in allCustomersFiltered" v-bind:key='customer.id' @click="SelectCustomerFinal(customer)">
                            <div class="row">
                                <div class="col-6">  <h6 v-if="customer.full_name" class="text-left">{{customer.full_name}}</h6>
                                    <p class="text-gray d-inline">{{customer.address_address}}</p></div>
                                <div class="col-6">
                                    <p class="text-gray text-right">{{customer.phone}}</p>
                                </div>


                            </div>


                        </li>

                    </ul>
                </div>



        </b-modal>
        <b-modal ref="default-customers" hide-footer static>

            <div class="text-center">
                <h5 class="text-dark">Customer data</h5>
                <hr/>
                <img src="/images/customer.png" style="max-height: 200px; width:auto" />
                <div class="btn-group">
                   <a class="btn btn-outline-secondary btn-sm mx-1 rounded text-truncate" @click="continueWithoutCustomer()">Continue without customer</a>
                    <a @click="showCustomersModalFinal" class="btn btn-outline-primary btn-sm mx-1 rounded">Select customer</a>

                </div>


            </div>


        </b-modal>

        <b-modal ref="new-customers-modal" hide-footer static>

            <div class="row">
                <div class="col"><a @click="showCustomersModal"><h6 class="text-primary"><i class="fas fa-angle-left"></i> Back</h6></a></div>
                <div class="col text-centre"><h2 class="font-weight-bold text-dark ">Add Customer</h2></div>
                </div>
                <div class="text-left" v-html="successMessage">{{successMessage}}</div>
                <div class="text-left text-danger py-2" v-if="customerForm.errorMessage !==''">{{customerForm.errorMessage}}</div>
                <div class="container py-3">
                    <!-- Actual search box -->
                    <form @submit.prevent="newCustomerInfo">
                        <div class="form-row py-1">
                            <div class="col-6">
                                <input class="form-control border-bottom"   v-model="customerForm.f_name" name="f_name" type="text" placeholder="First Name"/>
                                <!--<small class="text-danger">{{ errors.first('f_name') }}</small>-->

                            </div>
                            <div class="col-6">
                                <input class="form-control border-bottom"  v-model="customerForm.l_name" name="l_name" type="text" placeholder="Last Name"/>
                                <!--<small class="text-danger">{{ errors.first('l_name') }}</small>-->
                            </div>
                        </div>
                        <div class="form-group py-1">

                            <input class="form-control border-bottom" name="c_email" v-model="customerForm.c_email" type="email" placeholder="Email"/>


                        </div>
                        <div class="form-group">

                            <input class="form-control border-bottom"   v-model="customerForm.phone_no" name="phone_no" type="text" placeholder="Phone Number"/>


                        </div>
                        <div class="form-row py-1">
                            <div class="col-6">
                                <input class="form-control border-bottom" v-model="customerForm.h_no" name="h_no" type="text" placeholder="House Number"/>
                            </div>
                            <div class="col-6">
                                <input class="form-control border-bottom" v-model="customerForm.apartment" name="apartment" type="text" placeholder="Apartment"/>
                            </div>
                        </div>
                        <div class="form-row py-1">
                            <div class="col-6">
                                <input class="form-control border-bottom" v-model="customerForm.street" name="street" type="text" placeholder="Street"/>
                            </div>
                            <div class="col-6">
                                <input class="form-control border-bottom" v-model="customerForm.town" name="town" type="text" placeholder="Town"/>
                            </div>
                        </div>
                        <div class="form-group pt-3">
                            <button class="btn btn-primary btn-block">Add Customer</button>
                        </div>
                    </form>
                </div>



        </b-modal>

        </div>

      <!-- container fluid -->
    <!--qty modal-->


</template>

<script>
    import {
        mapGetters
    } from 'vuex';
    import MiniCheckout from './partials/MiniCheckout.vue';
    import productCacheService from './IndexDB/productCacheService'; // adjust path
    import customerCacheService from './IndexDB/customerCacheService';
    export default {
        mounted() {
            this.displayData('');
            this.$refs.search_item_focus.focus();
            this.checkUrlAndClearStore();
            this.getCustomers()
            this.getCompanySettings()
        },
        components: {
            MiniCheckout
        },
        data() {
            showModal: false
            return {
                searchItemTerm: '',
                isListView: false,
                page: 1,
                first_page: 1,
                last_page: null,
                current_page: '',
                next_page_url: '',
                prev_page_url: '',
                order_id: '',
                img: '',
                products: '',
                Cartitems: '',
                totalorderamount: '',
                newQty: '',
                selecteCartDetails: '',
                s_productcategory: 'All Items',
                allCategories: '',
                prodCategoryOptions: [],
                p_category: '',
                // customer data
                customerForm: {
                    town: '',
                    street: '',
                    apartment: '',
                    h_no: '',
                    phone_no: '',
                    c_email: '',
                    l_name: '',
                    f_name: '',
                    errorMessage: '',
                },
                searchTimeout: '',
                newServicePricing: '',
                //custom
                successMessage: '',
                allCustomers: '',
                searchCustomer: '',
                selectedCustomer: '',
                //response on error
                message_feedback: '',
                selectedCategory: '',
                continue_withno_customer: false,
                is_Retail: true,
                sortProducts: null,
                companySettings: {},
                totalDiscountApplied: '',
                discountError: '',
                fetchedProducts: {},
                isSubmitting: false,
            }
        },
        watch: {
            searchItemTerm(before, after) {
                this.searchItems()
                if (this.products.length === 1 && this.products[0].sku === this.searchItemTerm) {
                    this.addToCart(this.products[0])
                    this.searchItemTerm = ''
                }
            },
            'searchCustomer': function() {
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(() => {
                    this.getCustomers();
                }, 500); // Debounce delay (500ms)
            },
            sortProducts(before, after) {
                if (this.sortProducts === 'name-asc') {
                    this.products.sort((a, b) => a.product.localeCompare(b.product));
                }
                if (this.sortProducts === 'name-desc') {
                    this.products.sort((a, b) => b.product.localeCompare(a.product));
                }
                if (this.sortProducts === 'price-asc') {
                    this.products.sort((a, b) => a.ppu - b.ppu);
                }
                if (this.sortProducts === 'price-desc') {
                    this.products.sort((a, b) => b.ppu - a.ppu);
                }
            },
            selectedCategory(before, after) {
            if (this.selectedCategory && this.selectedCategory.id ) {
                this.s_productcategory = this.selectedCategory.name || 'Unnamed Category';
                this.displayData(this.selectedCategory.id);
            } else {
                this.s_productcategory = "All Items";

                this.displayData(''); // ensure empty string
            }
            },
            grandTotalAmount(before, after) {
                this.$store.commit('UpdateTotalAmount', this.grandTotalAmount)
            },
        },
        computed: {
            totalPrice() {
                return this.$store.state.cart.reduce((sum, item) => {
                    return sum + parseFloat(item.totalPrice);
                }, 0);
            },
            grandTotalAmount() {
                return this.totalPrice - this.totalDiscountApplied;
            },
            allCustomersFiltered() {
                return Object.values(this.allCustomers).filter(customer => {
                    if (!customer || !customer.full_name || !customer.phone) return false;
                    const search = this.searchCustomer.toLowerCase();
                    return (
                        customer.full_name.toLowerCase().includes(search) ||
                        customer.phone.toLowerCase().includes(search)
                    );
                });
            },
            ...mapGetters(['userDetails'])
        },
        methods: {
            continueWithoutCustomer() {
                this.continue_withno_customer = true;
                this.$refs['default-customers'].hide();
                this.Submit()
            },
            async hotReload() {
                 try {
                   await productCacheService.hotReloadLocalDB()

                   await this.displayData('')

                } catch (error) {

                }

            },
            showCartModal() {
                this.$refs['cart-modal'].show()
            },
            searchItems() {
                if (!Array.isArray(this.fetchedProducts)) {

                    return;
                }
                const searchTerms = this.searchItemTerm.toLowerCase().split(" ");
                this.products = this.fetchedProducts.filter((product) => {
                    const productName = product.product.toLowerCase();
                    const productSku = (product.sku !== null) ? product.sku.toLowerCase() : '';
                    return searchTerms.every((term) => {
                        return productName.includes(term) || productSku.includes(term);
                    });
                });
            },

            async getCustomers() {
                try {
                    const customers = await customerCacheService.getCustomers(this.searchCustomer);
                    this.allCustomers = customers;
                } catch (error) {

                }
            },
            addToCart(product) {
                product.is_Retail = this.is_Retail
                product.companySettings = this.companySettings
                if (product.remaining_units > 0 || this.companySettings.has_stock_buffer != 0 || product.is_service) {
                    this.companySettings.has_stock_buffer
                    this.$store.commit('addToCart', product);
                }
            },
            removeFromCart(item) {
                this.$store.commit('removeFromCart', item);
            },
            submitSearchItem(e) {
                e.preventDefault();
                this.searchItems();
                //    this.searchData()
            },
            showCustomersModal() {
                this.$refs['new-customers-modal'].hide();
                this.$refs['customers-modal'].show();
            },
            showCustomersModalFinal() {
                this.$refs['default-customers'].hide();
                this.$refs['customers-modal-final'].show();
            },
            AddnewcustomerModal() {
                this.$refs['customers-modal'].hide();
                this.$refs['new-customers-modal'].show();
                this.$refs['cart-modal'].hide();
            },
            SelectCustomer(customer) {
                // add this to store js
                this.$store.commit('addOrderingCustomer', customer);
                this.$refs['customers-modal'].toggle();
                this.selectedCustomer = this.$store.state.customerdata.full_name
                this.message_feedback = '';
            },
            SelectCustomerFinal(customer) {
                // add this to store js
                this.$store.commit('addOrderingCustomer', customer);
                this.selectedCustomer = this.$store.state.customerdata.full_name;
                this.message_feedback = '';
                this.Submit();
            },
            newCustomerInfo() {
                if (this.customerForm.phone_no === '' && this.customerForm.c_email === '') {
                    this.customerForm.errorMessage = "You need to enter atleast an email or customer phone number"
                } else {
                    this.customerForm.errorMessage = ''
                    axios.post('/api/newcustomer', {
                            ...this.customerForm
                        })
                        .then(result => {
                            if (result.status === 200) {
                                setTimeout(() => {
                                    this.successMessage = "<hr/><p><span class='text-success'><i class=\"bi bi-check-circle\"></i>  Customer added successfully</span></p>"
                                }, 3000)
                                this.$refs['new-customers-modal'].hide()
                                this.$refs['customers-modal'].hide()
                                this.$store.commit('addOrderingCustomer', result.data.customer);
                                this.selectedCustomer = result.data.customer.full_name
                            }
                        });
                }
            },
            changeQuantity(cart) {
                this.$refs['orderqty-modal'].show();
                this.newQty = cart.quantity;
                this.selecteCartDetails = cart
            },
            changePricingOnTheGo(cart) {
                this.$refs['changePriceModal'].show();
                // this.newQty = cart.quantity;
                this.newServicePricing = cart.ppu;
                this.selecteCartDetails = cart
            },
            checkUrlAndClearStore() {
                // Check if the current URL contains the 'add-to-order' parameter
                const urlParams = new URLSearchParams(window.location.search);
                if (urlParams.has('add-to-order')) {
                    this.resetStore();
                }
            },
            resetStore() {
                // Dispatch the action to reset the entire store
                this.$store.dispatch('resetStore');
            },
            async displayData(selectedCatId) {
            try {

                const products = await productCacheService.getProducts();
                const categories = await productCacheService.getCategories();

                this.loadProductData(products, categories, selectedCatId);
            } catch (error) {

            }
            },

            loadProductData(products, categories, selectedCatId) {


                    if (selectedCatId !== '') {
                        this.products = products.filter(product => product.productcat_id === selectedCatId);
                        this.fetchedProducts = [...this.products];

                    } else {
                        this.fetchedProducts = [...products];
                        this.products = [...products];
                    }


                    this.prodCategoryOptions = categories.map(value => ({
                        value: value,   // Assuming `id` is UUID
                        text: value.name,
                    }));
            },

            // displayData('') {
            //     let selectcat = (this.selectedCategory !== null) ? this.selectedCategory.id : '';
            //     axios.get('/api/betasell', {
            //             params: {
            //                 category: selectcat
            //             }
            //         })
            //         .then(result => {
            //             this.products = result.data.products;
            //             this.fetchedProducts = result.data.products;
            //             this.last_page = result.data.last_page_url;
            //             this.current_page = result.data.current_page;
            //             this.next_page_url = result.data.next_page_url;
            //             this.prev_page_url = result.data.prev_page_url;
            //             this.order_id = result.data.order_id;
            //             this.allCategories = result.data.allcategories;
            //             let cat_options = []
            //             $.each(this.allCategories, function(key, value) {
            //                 let prodcutcount = value.products.length;
            //                 let texts = value.name + ' (' + prodcutcount + ')';
            //                 cat_options.push({
            //                     value: value,
            //                     text: texts
            //                 }, )
            //             });
            //             this.prodCategoryOptions = cat_options;
            //             this.getCompanySettings()
            //         }).catch(error => {
            //             // TODO      // rem to add error reporting to be ent to email
            //         });
            // },
            Submit() {
                const urlParams = new URLSearchParams(window.location.search);
                if (this.totalDiscountApplied !== "" && !/^\d+(\.\d+)?$/.test(this.totalDiscountApplied)) {
                    return (this.discountError = "Discount should be a valid number");
                }
                if (this.$store.state.customerdata === 'Select Customer' && this.continue_withno_customer === false) {
                    // OPEN MODAL
                    this.$refs['default-customers'].show();
                } else {
                    if (this.$store.state.customerdata === 'Select Customer' && this.continue_withno_customer === true) {
                        let data = {
                            cart: JSON.stringify(this.$store.state.cart),
                            customerdata: JSON.stringify(0),
                            totalprice: JSON.stringify(this.$store.state.totalOrderAmount),
                            discount: this.totalDiscountApplied,
                            addTo: (urlParams.has('add-to-order')) ? urlParams.get('add-to-order') : false
                        };
                        this.isSubmitting = true;
                        axios.post('/api/order', data)
                            .then(result => {
                                if (result.status === 200) {
                                   this.$store.commit('resetStore')
                                    window.location.href = '/checkout/' + result.data.id;
                                }
                            }).catch(error => {
                                this.isSubmitting = false;
                            })
                    } else if (this.$store.state.customerdata !== 'Select Customer' && this.continue_withno_customer === false) {
                        let data = {
                            cart: JSON.stringify(this.$store.state.cart),
                            customerdata: JSON.stringify(this.$store.state.customerdata),
                            totalprice: JSON.stringify(this.$store.state.totalOrderAmount),
                            discount: this.totalDiscountApplied,
                            addTo: (urlParams.has('add-to-order')) ? urlParams.get('add-to-order') : false
                        };
                        this.isSubmitting = true;
                        axios.post('/api/order', data)
                            .then(result => {
                                // window.localStorage.clear();
                                window.location.href = '/checkout/' + result.data.id;
                            }).catch(error => {
                                this.isSubmitting = true;
                            })
                    }
                }
            },
            getCompanySettings() {
                if (!this.userDetails) {
                    axios.get('/api/settings')
                        .then(results => {
                            this.companySettings = results.data
                        }).catch(errors => {});
                } else {
                    this.companySettings = this.userDetails.company.companysettings
                }
            },
            processNewQty() {
                this.$refs['orderqty-modal'].hide();
                if (!this.selecteCartDetails.is_service) {
                    if (this.selecteCartDetails.remaining_units >= this.newQty) {
                        let toChangeqQty = {
                            quantity: this.newQty,
                            cart_id: this.selecteCartDetails.id
                        };
                        toChangeqQty.is_Retail = this.is_Retail
                        this.$store.commit('UpdateOrderQty', toChangeqQty);
                    } else {
                        this.$toasts.push({
                            type: 'error',
                            message: "The quantity cannot more than " + this.selecteCartDetails.remaining_units
                        })
                    }
                } else {
                    let toChangeqQty = {
                        quantity: this.newQty,
                        cart_id: this.selecteCartDetails.id
                    };
                    toChangeqQty.is_Retail = this.is_Retail
                    this.$store.commit('UpdateOrderQty', toChangeqQty);
                }
            },
            processNewPricesOnTheGo() {


                if (this.selecteCartDetails.is_service) {

                    this.$refs['changePriceModal'].hide();
                    let newServicePricing = {
                        newPriceChange: this.newServicePricing,
                        cart_id: this.selecteCartDetails.id
                    };
                    this.$store.commit('updatePricesOnTheGo', newServicePricing);
                } else if (!this.selecteCartDetails.is_service && this.companySettings.allows_price_change_on_the_go) {
                    let newServicePricing = {
                        newPriceChange: this.newServicePricing,
                        cart_id: this.selecteCartDetails.id
                    };
                    this.$store.commit('updatePricesOnTheGo', newServicePricing);
                    this.$refs['changePriceModal'].hide();
                }
            },
            nextPage() {
                let nextPage = this.current_page + 1;
                window.history.replaceState(null, null, "?page=" + nextPage);
                this.displayData('');
            },
            prevPage() {
                let prevPage = this.current_page - 1;
                window.history.replaceState(null, null, "?page=" + prevPage);
                this.displayData('');
            },
            searchData() {
                this.displayData('');
                window.history.replaceState(null, null, "?page=1");
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(0).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
        }
    }
</script>

<style>
    .image-table {
        width: 40px;
        height: 40px;
        object-fit: cover;
        margin-right: 10px;
        ;
    }
    .has-search .form-control {
        padding-left: 2.375rem;
    }
    .btn-animation {
        animation: fadeIn 0.5s ease-in-out;
    }
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    .has-search .form-control-feedback {
        position: absolute;
        z-index: 2;
        display: block;
        width: 2.375rem;
        height: 2.375rem;
        line-height: 2.375rem;
        text-align: center;
        pointer-events: none;
        color: #aaa;
    }
    @media only screen and (max-width: 768px) {
        .float {
            position: fixed;
            width: 60px;
            height: 60px;
            bottom: 70px;
            right: 40px;
            background-color: #fd4719;
            color: #FFF;
            border-radius: 50px;
            text-align: center;
            box-shadow: 2px 2px 3px #fd4719;
        }
        .my-float {
            margin-top: 22px;
            color: #FFF;
        }
    }
</style>
